import { HStack, Text } from '@chakra-ui/react'
import { NewListButton } from 'presentation/screens/ListsScreen/component/NewListButton/NewListButton'

export const ListsHeader = () => (
  <HStack spacing={3}>
    <Text flex={1} textStyle='h4' color='graystrong.500'>List Manager</Text>
    <NewListButton />
  </HStack>
)
